module.exports = __webpack_public_path__ + "static/scale-model-of-university-of-nebraska-state-museum-in-lincoln-nebraska-5345cdf605d56d799e905c6c0da3c325.png";